export const DEFAULT_UNDERGROUND_TRAVEL_TIME = 45;
